/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_increase_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the percentage increase formula?`)
};

const es_pct_increase_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es la fórmula del aumento porcentual?`)
};

const de_pct_increase_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie lautet die Formel für den prozentualen Anstieg?`)
};

const nl_pct_increase_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is de formule voor percentagestijging?`)
};

const fr_pct_increase_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la formule de l'augmentation en pourcentage ?`)
};

const it_pct_increase_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è la formula dell'aumento percentuale?`)
};

const pt_br2_pct_increase_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a fórmula do aumento percentual?`)
};

const pt_pct_increase_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a fórmula do aumento percentual?`)
};

const ja_pct_increase_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセント増加の計算式は？`)
};

const zh_pct_increase_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`百分比增长公式是什么？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_increase_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_increase_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_increase_faq1_q", locale)
	if (locale === "en") return en_pct_increase_faq1_q(inputs)
	if (locale === "es") return es_pct_increase_faq1_q(inputs)
	if (locale === "de") return de_pct_increase_faq1_q(inputs)
	if (locale === "nl") return nl_pct_increase_faq1_q(inputs)
	if (locale === "fr") return fr_pct_increase_faq1_q(inputs)
	if (locale === "it") return it_pct_increase_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_pct_increase_faq1_q(inputs)
	if (locale === "pt") return pt_pct_increase_faq1_q(inputs)
	if (locale === "ja") return ja_pct_increase_faq1_q(inputs)
	return zh_pct_increase_faq1_q(inputs)
};